<h2 mat-dialog-title>
  {{ 'epd.functions.careplan-nnn.diagnosis-section.info-dialog.title' | translate | capitalize }}
</h2>
<mat-dialog-content class="diagnosis-info">
  <ol class="diagnosis-info__sections">
    <li class="diagnosis-info__section">
      <h3 class="diagnosis-info__title">
        {{ 'epd.functions.careplan-nnn.diagnosis-section.info-dialog.pes.title' | translate | capitalize }}
      </h3>
      <ul class="diagnosis-info__items">
        @for (item of pesItems; track item) {
          <li class="diagnosis-info__line">
            <span class="diagnosis-info__question">
              {{
                'epd.functions.careplan-nnn.diagnosis-section.info-dialog.pes.' + item + '.label'
                  | translate
                  | capitalize
              }}
            </span>
            {{
              'epd.functions.careplan-nnn.diagnosis-section.info-dialog.pes.' + item + '.text' | translate | capitalize
            }}
          </li>
        }
      </ul>
    </li>
    <li class="diagnosis-info__section">
      <h3 class="diagnosis-info__title">
        {{ 'epd.functions.careplan-nnn.diagnosis-section.info-dialog.sources.title' | translate | capitalize }}
      </h3>
      <p class="diagnosis-info__line">
        <span class="diagnosis-info__question">
          {{ 'epd.functions.careplan-nnn.diagnosis-section.info-dialog.sources.label' | translate | capitalize }}
        </span>
        {{ 'epd.functions.careplan-nnn.diagnosis-section.info-dialog.sources.text' | translate | capitalize }}
      </p>
    </li>
    <li class="diagnosis-info__section">
      <h3 class="diagnosis-info__title">
        {{ 'epd.functions.careplan-nnn.diagnosis-section.info-dialog.relevance.title' | translate | capitalize }}
      </h3>
      <p class="diagnosis-info__line">
        <span class="diagnosis-info__question">
          {{ 'epd.functions.careplan-nnn.diagnosis-section.info-dialog.relevance.label' | translate | capitalize }}
        </span>
        {{ 'epd.functions.careplan-nnn.diagnosis-section.info-dialog.relevance.text' | translate | capitalize }}
      </p>
    </li>
  </ol>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" mat-dialog-close>
    {{ 'general.actions.close' | translate | capitalize }}
  </button>
</mat-dialog-actions>
